import { Link } from "react-router-dom";
import Compair from "../icons/Compair";
import QuickViewIco from "../icons/QuickViewIco";
import Star from "../icons/Star";
import ThinLove from "../icons/ThinLove";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "LKR",
});

export default function ProductCardRowStyleTwo({ className, datas, type }) {
  const currentDate = new Date();

  const hasSpecialPrice =
    datas.minsp !== null &&
    datas.maxsp !== null &&
    datas.discount_start_date !== null &&
    datas.discount_end_date !== null &&
    currentDate >= new Date(datas.discount_start_date) &&
    currentDate <= new Date(datas.discount_end_date);

  let price;
  let oldPrice;
  let discountPercent;

  if (hasSpecialPrice) {
    if (datas.minsp === datas.maxsp) {
      oldPrice = formatter.format(datas.minp);
      price = formatter.format(datas.minsp);
    } else {
      let p1 = formatter.format(datas.minp);
      let p2 = formatter.format(datas.maxp);
      oldPrice = p1 + "-" + p2;
      let sp1 = formatter.format(datas.minsp);
      let sp2 = formatter.format(datas.maxsp);
      price = sp1 + "-" + sp2;
    }
    discountPercent = Math.round(
      ((datas.minp - datas.minsp) / datas.minp) * 100
    );
  } else {
    if (datas.minp === datas.maxp) {
      price = formatter.format(datas.maxp);
    } else {
      let p1 = formatter.format(datas.minp);
      let p2 = formatter.format(datas.maxp);
      price = p1 + "-" + p2;
    }
  }

  return (
    <Link to={`/single-product/${datas.id}`}>
      <div
        data-aos="fade-left"
        className={`product-row-card-style-one w-full h-[250px] bg-white group relative overflow-hidden ${
          className || ""
        }`}
      >
        <div className="flex space-x-5 items-center w-full h-full lg:p-[30px] sm:p-5 p-2">
          <div className="lg:w-1/2 w-1/3 h-full">
            <img
              src={process.env.REACT_APP_IMAGE_FOLDER + `/` + datas.name}
              alt=""
              className="w-full h-full object-contain"
            />
          </div>
          <div className="flex-1 flex flex-col justify-center h-full">
            <div>
              {/* reviews */}
              {/*<div className="flex space-x-1 mb-3">*/}
              {/*  {Array.from(Array(datas.review), () => (*/}
              {/*    <span key={datas.review + Math.random()}>*/}
              {/*      <Star />*/}
              {/*    </span>*/}
              {/*  ))}*/}
              {/*</div>*/}
              <Link to={`/single-product/${datas.id}`}>
                <p className="title mb-2 sm:text-[15px] text-[13px] font-600 text-qblack leading-[24px] line-clamp-2 hover:text-blue-600">
                  {datas.p_name}
                </p>
              </Link>
              <div className="flex items-end space-x-2 mt-2">
                <span className="text-xl font-bold text-qred">{price}</span>
                {hasSpecialPrice && (
                  <span className="text-base text-gray-400 line-through">
                    {oldPrice}
                  </span>
                )}
                {hasSpecialPrice && (
                  <span className="text-xs bg-green-100 text-green-700 rounded px-2 py-0.5 font-semibold">
                    {discountPercent}% OFF
                  </span>
                )}
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-600 mt-1 ml-2">
                Or 3 x
                <span className="font-semibold text-qblack">
                  {formatter.format(
                    Math.ceil(
                      ((hasSpecialPrice ? datas.minsp : datas.minp) / 3) * 1.11
                    )
                  )}
                </span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/koko.png.webp`}
                  alt="KOKO"
                  className="w-8 h-8 object-contain"
                />
              </div>
              {/* <Link
              to={`/single-product/${datas.id}`}
              type="button"
              className="w-[110px] h-[30px]"
            >
              <span
                className={type === 3 ? "theme-main-btn" : "theme-main-btn"}
              >
                Select Options
              </span>
            </Link> */}
            </div>
          </div>
        </div>
        {/* quick-access-btns */}
        {/* <div className="quick-access-btns flex flex-col space-y-2 absolute group-hover:right-4 -right-10 top-[30px]  transition-all duration-300 ease-in-out">
          <button>
            <span className="w-10 h-10 flex justify-center items-center bg-primarygray rounded">
              <QuickViewIco />
            </span>
          </button>
          <button>
            <span className="w-10 h-10 flex justify-center items-center bg-primarygray rounded">
              <ThinLove />
            </span>
          </button>
          <Link to="javascript:void(0)">
          <span className="w-10 h-10 flex justify-center items-center bg-primarygray rounded">
            <Compair />
          </span>
        </Link>
        </div> */}
      </div>
    </Link>
  );
}
